/*
  Pack selector.

  Packs are real variants, so switching one is a local swap: every price string
  was already rendered by Liquid in the visitor's currency and pushed onto the
  radio as a data attribute. No fetch, no re-render, nothing to wait for.
*/
class PocketroPackSelector extends HTMLElement {
  connectedCallback() {
    this.radios = Array.from(this.querySelectorAll('input[type="radio"]'));
    if (!this.radios.length) return;

    this.form = this.closest('[data-pocketro-product]')?.querySelector('form[action*="/cart/add"]');
    this.variantInput = this.form?.querySelector('input[name="id"]');
    this.priceTargets = this.rootScope().querySelectorAll('[data-pack-price]');
    this.nameTargets = this.rootScope().querySelectorAll('[data-pack-name]');
    this.submitButton = this.form?.querySelector('[type="submit"]');
    this.submitText = this.submitButton?.querySelector('[data-add-to-cart-text]');

    this.onChange = this.onChange.bind(this);
    this.addEventListener('change', this.onChange);

    const checked = this.radios.find((radio) => radio.checked);
    if (checked) this.apply(checked, { pushUrl: false });
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.onChange);
  }

  rootScope() {
    return this.closest('[data-pocketro-product]') || document;
  }

  onChange(event) {
    const radio = event.target;
    if (!radio.matches('input[type="radio"]')) return;
    this.apply(radio, { pushUrl: true });
  }

  apply(radio, { pushUrl }) {
    if (this.variantInput) this.variantInput.value = radio.value;

    this.priceTargets.forEach((node) => {
      node.textContent = radio.dataset.price || '';
    });
    this.nameTargets.forEach((node) => {
      node.textContent = radio.dataset.name || '';
    });

    const available = radio.dataset.available === 'true';
    if (this.submitButton) {
      this.submitButton.disabled = !available;
      if (this.submitText) {
        this.submitText.textContent = available
          ? this.submitText.dataset.labelAvailable || this.submitText.textContent
          : this.submitText.dataset.labelSoldOut || this.submitText.textContent;
      }
    }

    if (pushUrl && radio.dataset.url && window.history?.replaceState) {
      window.history.replaceState({}, '', radio.dataset.url);
    }

    this.dispatchEvent(
      new CustomEvent('pocketro:pack:change', {
        bubbles: true,
        detail: { variantId: radio.value, price: radio.dataset.price, available },
      })
    );
  }
}

if (!customElements.get('pocketro-pack-selector')) {
  customElements.define('pocketro-pack-selector', PocketroPackSelector);
}
